import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LayerSwitcherService } from 'src/app/map-openlayers/layerswitcher/layerswitcher.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { TunnelSectionsService } from '../tunnel-sections.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tunnel-sections-dashboard',
  templateUrl: './tunnel-sections-dashboard.component.html',
  styleUrls: ['./tunnel-sections-dashboard.component.css'],
  providers: [LayerSwitcherService]
})
export class TunnelSectionsDashboardComponent implements OnInit, OnDestroy,  AfterViewInit { 
  
  selectSectionOnMap: Subscription;
  sectionClickedOnMapSubscription: Subscription;
    
  constructor(public translate: TranslateService,
    public lsService: LayerSwitcherService,
    public tsService: TunnelSectionsService,
    public dialog: MatDialog,
    public router: Router
    ) { }
    
  ngOnDestroy(): void {
    if (this.selectSectionOnMap) this.selectSectionOnMap.unsubscribe();
    if (this.sectionClickedOnMapSubscription) this.sectionClickedOnMapSubscription.unsubscribe(); 
  }
  
  ngOnInit(): void {
    
    this.lsService.setShowLegendsButton(true);

    this.selectSectionOnMap = this.tsService.toSelectSectionOnMap.subscribe((id: string) => {
      this.lsService.selectSection(id);
    });

    this.sectionClickedOnMapSubscription = this.lsService.sectionClickedOnMap.subscribe((id) => {
      this.tsService.toSectionClickedOnMap(id);
    });

  }

  dragEnd(unit, { sizes }) {
    this.lsService.onResizeContainer();
    console.log("drag end");
  }

  ngAfterViewInit(): void {
    this.initForm();
  }

  initForm()
  {
    this.lsService.toAddSectionLayer(null);  
  }
}
